var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightDirectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.99974C15 7.1655 14.9342 7.32447 14.8169 7.44168C14.6997 7.55889 14.5408 7.62474 14.375 7.62474H2.1336L6.69219 12.1826C6.75026 12.2406 6.79632 12.3096 6.82775 12.3854C6.85918 12.4613 6.87535 12.5426 6.87535 12.6247C6.87535 12.7069 6.85918 12.7882 6.82775 12.864C6.79632 12.9399 6.75026 13.0089 6.69219 13.0669C6.63412 13.125 6.56519 13.1711 6.48931 13.2025C6.41344 13.2339 6.33213 13.2501 6.25 13.2501C6.16788 13.2501 6.08656 13.2339 6.01069 13.2025C5.93482 13.1711 5.86589 13.125 5.80782 13.0669L0.182816 7.44193C0.124706 7.38388 0.0786063 7.31495 0.0471536 7.23907C0.0157009 7.1632 -0.000488281 7.08187 -0.000488281 6.99974C-0.000488281 6.9176 0.0157009 6.83627 0.0471536 6.7604C0.0786063 6.68453 0.124706 6.61559 0.182816 6.55755L5.80782 0.93255C5.92509 0.815274 6.08415 0.74939 6.25 0.74939C6.41586 0.74939 6.57492 0.815274 6.69219 0.93255C6.80947 1.04983 6.87535 1.20888 6.87535 1.37474C6.87535 1.54059 6.80947 1.69965 6.69219 1.81692L2.1336 6.37474H14.375C14.5408 6.37474 14.6997 6.44059 14.8169 6.5578C14.9342 6.67501 15 6.83398 15 6.99974Z",
    fill: "#005596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDirectionIcon);
export default __webpack_public_path__ + "static/media/right-direction-icon.635554e893b323b8da898f415a2a513a.svg";
export { ForwardRef as ReactComponent };